module.exports = __webpack_public_path__ + "static/media/web-logo-trans.d1f79280.png";